import "./administrative.css"

const Administrative = () => {
    return (
        <div className="administrative">
            
        </div>
    )
}

export default Administrative
